<div class="user-area-wrapper">
  <h1 class="user-area-title">{{ 'user.stats.title' | translateByCustomerType: customerType.dbValue }}</h1>
  <opac-user-title [title]="'user.stats.title' | translateByCustomerType: customerType.dbValue"></opac-user-title>

  <opac-user-section *ngIf="!noStatsAvailable" [title]="'user.stats.lastUsage' | translate">
    <app-user-stats-last-usage-table [userStatsBundle]="userStatsBundle"></app-user-stats-last-usage-table>
  </opac-user-section>

  <opac-user-section [title]="'general.total' | translate">
    <app-user-stats-total-table [userStatsBundle]="userStatsBundle"></app-user-stats-total-table>

    <div class="user-stats__chart" *ngIf="readingStats?.minutesReadByHourInLast30days">
      <p class="chart__title">{{ 'user.stats.schedule' | translate }}</p>
      <p>{{ 'user.stats.graphInfo' | translate }}</p>
      <p>{{ 'user.stats.last30days' | translate }}</p>
      <div class="format-selection-bar">
        <app-resource-type-selector (resourceFormatSelected)="loadChartData($event)"></app-resource-type-selector>
      </div>

      <div class="chart-container">
        <canvas
          baseChart
          [options]="chartOptions"
          [datasets]="chartData"
          [labels]="chartLabels"
          [colors]="chartColors"
          legend="true"
          chartType="bar"></canvas>
      </div>
    </div>
  </opac-user-section>
</div>
